<template>
  <div id="mainDiv">
    <div id="content">
      <el-tabs type="border-card" style="height: 100%;">
        <el-tab-pane label="工程划分类型" style="height: 100%;">
          <el-table
            :data="tableData"
            border
            highlight-current-row
            size="mini"
            :header-cell-style="{background:'#F5F7FA',color:'#606266'}"
            @cell-click="tableClicked"
            style="width: 100%"
            ref="table"
            height="100%">
            <el-table-column
              type="index"
              label=" "
              width="35">
            </el-table-column>
            <el-table-column
              prop="name"
              align="left"
              header-align="center"
              label="姓名">
            </el-table-column>
            <el-table-column
              prop="code"
              align="center"
              width="50"
              label="编码">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="结构物类型" style="height: 100%;">
          <el-tree ref="tree" node-key="id" :props="defaultProps" highlight-current :load="loadNode" lazy @node-click="handleNodeClick"></el-tree>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import {getRoots} from "../api/prjPart";
  import {getTree} from "../api/prjTypeModel";

  export default {
    name: "QualityFormConfigurationType",
    props: {
      parentMsg: Object
    },
    data() {
      return {
        tableData:[],
        defaultProps: {
          children: 'children',
          label: 'text',
          isLeaf: 'leaf'
        }
      }
    },
    methods: {
      getTableData() {
        getRoots().then(response => {
          this.tableData = response
          if (this.tableData.length > 0) {
            this.$refs.table.setCurrentRow(this.tableData[0])
            this.$emit('getValue', {partType:this.tableData[0].code, partName:this.tableData[0].name})
          }
        }).catch(error => {
          console.log('error:' + error.toString())
        })
      },
      loadNode(node, resolve) {
        if (node.level=== 0) {
          this.getTreeData('', resolve)
        } else {
          this.getTreeData(node.data.id, resolve)
        }
      },
      getTreeData(id, resolve) {
        getTree(this.$qs.stringify({id:id})).then(response => {
          for (var index in response) {
            response[index].leaf = response[index].state == 'open'
          }
          resolve(response)
        }).catch(error => {
          console.log('error:' + error.toString())
        })
      },
      tableClicked(row) {
        this.$refs.tree.setCurrentKey(null)
        this.$emit('getValue', {partType:row.code, partName:row.name})
      },
      handleNodeClick(data) {
        this.$refs.table.setCurrentRow()
        this.$emit('getValue', {partTypeCode:data.id, partTypeName:data.text})
      }
    },
    mounted() {
      this.getTableData()
    }
  }
</script>

<style>
  #mainDiv {
    height: 98%;
    height: -webkit-calc(100% - 20px);
    height: calc(100% - 20px);
    padding: 10px 0;
  }
  #topBar {
    margin-top: 5px;
  }
  #name {
    float: left;
    color: black;
    font-size: 18px;
    font-weight: bold;
    margin-left: 15px;
  }
  #content {
    height: 100%;
    padding: 0px;
    margin: 0px;
  }
  #content .el-tabs--border-card>.el-tabs__content {
    height: 94.7%;
    padding: 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/QualityFormConfigurationType.vue